import { useState, useEffect } from "react";
import ReportImageFrame from "./ReportImageFrame";
import ImageSelectorFrame from "./ImageSelectorFrame";
import Container from "../../../../common/Container";

const ImageSelectorRouter = ({
    metaData,
    setMetaData,
    addTemplateToSelected,
    statusMessage,
    buttonIsHidden,
    selectedTemplates,
    removeSelectedTemplate,
    isBackgroundBlur,
    setIsBackgroundBlur,
    setButtonIsHidden,
    priceOptions,
}) => {
    const [isReporting, setIsReporting] = useState(false);
    const [isReportedButtonOff, setIsReportedButtonOff] = useState(false);
    const [reasonValue, setReasonValue] = useState("Inappropriate");

    useEffect(() => {
        // Enabled backgound blur when metaData was selected
        if (
            metaData &&
            isBackgroundBlur !== "ImageSelectorSearchLayerContainerBlur"
        ) {
            setIsBackgroundBlur("ImageSelectorSearchLayerContainerBlur");
        }

        // Disable blur when no metaData was selected
        if (!metaData && isBackgroundBlur) setIsBackgroundBlur("");
    }, [metaData, isBackgroundBlur, setButtonIsHidden, setIsBackgroundBlur]);

    // Return early if there is no meta data selected
    if (!metaData) return <></>;

    let content = (
        <ImageSelectorFrame
            setMetaData={setMetaData}
            setIsReporting={setIsReporting}
            metaData={metaData}
            addTemplateToSelected={addTemplateToSelected}
            buttonIsHidden={buttonIsHidden}
            statusMessage={statusMessage}
            selectedTemplates={selectedTemplates}
            removeSelectedTemplate={removeSelectedTemplate}
            priceOptions={priceOptions}
        />
    );

    if (isReporting) {
        content = (
            <ReportImageFrame
                setMetaData={setMetaData}
                setIsReporting={setIsReporting}
                metaData={metaData}
                setReasonValue={setReasonValue}
                setIsReportedButtonOff={setIsReportedButtonOff}
                isReportedButtonOff={isReportedButtonOff}
                reasonValue={reasonValue}
            />
        );
    }

    let displayComponent = (
        <>
            <div className="ImageSelectorOverLayeContainer">
                <div
                    className="ImageSelectorAnimationContainer"
                    id="ImageSelectorAnimationContainer"
                >
                    <Container
                        border={true}
                        content={content}
                        maxWidth="20em"
                        width="20em"
                    />
                </div>
            </div>
        </>
    );

    return displayComponent;
};

export default ImageSelectorRouter;
